import { FC, ReactNode } from 'react'

interface ShowcaseCardProps {
	children: ReactNode
	className?: string
}

const ShowcaseCard: FC<ShowcaseCardProps> = ({ children, className = '' }) => (
	<div className={`bg-white/10 rounded-lg p-6 backdrop-blur-xs transition-all hover:bg-white/20 ${className}`}>
		{children}
	</div>
)

export default ShowcaseCard
